"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _drinkCard = require("@/api/basic/drinkCard");
var _couponPackage = require("@/api/basic/couponPackage");
var _utils = require("@/utils");
var _couponExpiry = require("@/utils/couponExpiry");
var _excluded = ["_pkg", "_uploading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultForm = function defaultForm() {
  return {
    id: null,
    title: '',
    title2: '',
    imgUrl: '',
    bgImgUrl: '',
    bdImgUrl: '',
    originalPrice: null,
    buyPrice: null,
    promptMsg: '',
    level: null,
    rule: '',
    isEnable: 1,
    isTjPlus: 0,
    zone: '',
    sort: 0,
    showInCart: 1,
    showInPayment: 1,
    items: [],
    dishGroupIds: []
  };
};
var _default = exports.default = {
  name: 'drinkCardList',
  data: function data() {
    return {
      loading: false,
      saving: false,
      searchForm: {
        keywords: '',
        isEnable: null,
        page: 1,
        limit: 20
      },
      total: 0,
      tableData: [],
      editVisible: false,
      activeTab: 'basic',
      editForm: defaultForm(),
      couponPackages: [],
      couponTypes: [],
      allDishGroups: [],
      dishGroupKeyword: '',
      packagesLoaded: false,
      dishGroupsLoaded: false,
      dishGroupsLoading: false,
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      uploadingMap: {
        imgUrl: false,
        bgImgUrl: false,
        bdImgUrl: false
      },
      imgFields: [{
        key: 'imgUrl',
        label: '封面图'
      }, {
        key: 'bgImgUrl',
        label: '背景图'
      }, {
        key: 'bdImgUrl',
        label: '榜单图'
      }],
      changeLogVisible: false,
      changeLogLoading: false,
      changeLogs: []
    };
  },
  computed: {
    filteredDishGroups: function filteredDishGroups() {
      if (!this.dishGroupKeyword) return this.allDishGroups;
      var kw = this.dishGroupKeyword.toLowerCase();
      return this.allDishGroups.filter(function (g) {
        return (g.name || '').toLowerCase().includes(kw) || (g.nameEn || '').toLowerCase().includes(kw);
      });
    }
  },
  mounted: function mounted() {
    this.fetchList();
    this.fetchEnabledPackages();
  },
  methods: {
    parseTime: _utils.parseTime,
    openChangeLogs: function openChangeLogs() {
      var _this = this;
      this.changeLogVisible = true;
      this.changeLogLoading = true;
      this.changeLogs = [];
      (0, _drinkCard.getDrinkCardItemChangeLogs)(this.editForm.id).then(function (res) {
        _this.changeLogs = res.data || [];
      }).finally(function () {
        _this.changeLogLoading = false;
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      (0, _drinkCard.getDrinkCardPage)(this.searchForm).then(function (res) {
        _this2.tableData = res.records || [];
        _this2.total = res.total || 0;
      }).catch(function () {
        _this2.tableData = [];
        _this2.total = 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    fetchEnabledPackages: function fetchEnabledPackages() {
      var _this3 = this;
      this.packagesLoaded = true;
      (0, _couponPackage.listEnabledPackages)().then(function (res) {
        _this3.couponPackages = res.data || [];
      }).catch(function () {
        _this3.packagesLoaded = false;
      });
    },
    fetchDishGroups: function fetchDishGroups() {
      var _this4 = this;
      this.dishGroupsLoaded = true;
      this.dishGroupsLoading = true;
      (0, _drinkCard.getDishGroupList)({
        page: 1,
        limit: 500
      }).then(function (res) {
        _this4.allDishGroups = res && res.records || [];
      }).catch(function () {
        _this4.dishGroupsLoaded = false;
      }).finally(function () {
        _this4.dishGroupsLoading = false;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      var _this5 = this;
      if (tab.name === 'items') {
        if (!this.packagesLoaded) this.fetchEnabledPackages();
        // 编辑已有品项时补加载 _pkg 详情
        this.editForm.items.forEach(function (item) {
          if (item.packageId && !item._pkg) _this5.onPackageSelect(item, item.packageId, true);
        });
      }
      if (tab.name === 'goods' && !this.dishGroupsLoaded) {
        this.fetchDishGroups();
      }
    },
    handleFilter: function handleFilter() {
      this.searchForm.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        keywords: '',
        isEnable: null,
        page: 1,
        limit: 20
      };
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleAdd: function handleAdd() {
      this.editForm = defaultForm();
      this.activeTab = 'basic';
      this.editVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var _this6 = this;
      this.editForm = defaultForm();
      this.activeTab = 'basic';
      this.editVisible = true;
      (0, _drinkCard.getDrinkCardDetail)(row.id).then(function (res) {
        console.log('[drinkCard edit] detail res:', JSON.stringify(res));
        var data = res.data || {};
        _this6.editForm = _objectSpread(_objectSpread(_objectSpread({}, defaultForm()), data), {}, {
          items: (data.items || []).map(function (i) {
            return _objectSpread({}, i);
          }),
          dishGroupIds: data.dishGroupIds || []
        });
        console.log('[drinkCard edit] editForm.items:', JSON.stringify(_this6.editForm.items));
        if (!_this6.packagesLoaded) _this6.fetchEnabledPackages();
        _this6.editForm.items.forEach(function (item) {
          if (item.packageId) _this6.onPackageSelect(item, item.packageId, true);
        });
      }).catch(function (err) {
        console.error('[drinkCard edit] error:', err);
      });
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this7 = this;
      var newStatus = row.isEnable === 1 ? 0 : 1;
      this.$confirm("\u786E\u5B9A\u8981".concat(newStatus === 1 ? '启用' : '禁用', "\u8BE5\u7545\u996E\u5361\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        (0, _drinkCard.updateDrinkCardStatus)({
          id: row.id,
          isEnable: newStatus
        }).then(function () {
          _this7.$message.success('操作成功');
          _this7.fetchList();
        });
      }).catch(function () {});
    },
    handleDelete: function handleDelete(row) {
      var _this8 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u7545\u996E\u5361\u300C".concat(row.title, "\u300D\u5417\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\u3002"), '提示', {
        type: 'warning'
      }).then(function () {
        (0, _drinkCard.deleteDrinkCard)(row.id).then(function () {
          _this8.$message.success('删除成功');
          _this8.fetchList();
        });
      }).catch(function () {});
    },
    addItem: function addItem() {
      this.editForm.items.push({
        packageId: null,
        sort: this.editForm.items.length,
        names: '',
        iconUrl: '',
        _pkg: null
      });
    },
    onPackageSelect: function onPackageSelect(item, pkgId, isInit) {
      var _this9 = this;
      if (!pkgId) {
        item._pkg = null;
        return;
      }
      var prevPkgId = item._prevPkgId;
      (0, _couponPackage.getPackageWithItems)(pkgId).then(function (res) {
        var pkg = res.data || null;
        // 用户主动选券时才校验过期（初始化加载跳过）
        if (!isInit && pkg && pkg.items) {
          var expired = pkg.items.find(function (c) {
            return !_this9.isCouponValid(c);
          });
          if (expired) {
            _this9.$message.error("\u5238\u5305\u300C".concat(pkg.packageAlias || pkg.packageName, "\u300D\u4E2D\u5B58\u5728\u5DF2\u8FC7\u671F\u7684\u5238\u300C").concat(expired.couponAlias || expired.couponTitle || expired.crmCouponId, "\u300D\uFF0C\u8BF7\u5148\u5728CRM\u66F4\u65B0\u540E\u91CD\u65B0\u540C\u6B65"));
            _this9.$nextTick(function () {
              _this9.$set(item, 'packageId', prevPkgId || null);
              _this9.$set(item, '_pkg', null);
            });
            return;
          }
        }
        item._prevPkgId = pkgId;
        _this9.$set(item, '_pkg', pkg);
        // 展示别名/图片为空时，默认带出券包别名/封面（已填则保留自定义值）
        if (pkg) {
          if (item.names === undefined || item.names === null || item.names === '') {
            _this9.$set(item, 'names', pkg.packageAlias || pkg.packageName || '');
          }
          if (item.iconUrl === undefined || item.iconUrl === null || item.iconUrl === '') {
            _this9.$set(item, 'iconUrl', pkg.pkgImgUrl || '');
          }
        }
      }).catch(function () {});
    },
    formatYxq: _couponExpiry.formatYxq,
    isCouponValid: function isCouponValid(row) {
      return !(0, _couponExpiry.isCouponConfigExpired)(row);
    },
    formatDate: function formatDate(val) {
      if (!val) return '';
      var d = new Date(val);
      if (isNaN(d.getTime())) return val;
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
    },
    handleSave: function handleSave() {
      var _this0 = this;
      this.$refs.editFormRef.validate(function (valid) {
        if (!valid) {
          _this0.activeTab = 'basic';
          return;
        }
        // 校验券包内是否有过期券
        var expiredItems = [];
        _this0.editForm.items.forEach(function (item) {
          if (item._pkg && item._pkg.items) {
            item._pkg.items.forEach(function (coupon) {
              if (!_this0.isCouponValid(coupon)) {
                expiredItems.push("\u5238\u5305\u300C".concat(item._pkg.packageAlias || item._pkg.packageName, "\u300D\u4E2D\u7684\u5238\u300C").concat(coupon.couponAlias || coupon.couponTitle || coupon.crmCouponId, "\u300D\u5DF2\u8FC7\u671F"));
              }
            });
          }
        });
        if (expiredItems.length > 0) {
          _this0.$message.error('存在已过期的券，请先替换或移除：' + expiredItems[0]);
          _this0.activeTab = 'items';
          return;
        }
        _this0.saving = true;
        var payload = _objectSpread(_objectSpread({}, _this0.editForm), {}, {
          items: _this0.editForm.items.map(function (_ref) {
            var _pkg = _ref._pkg,
              _uploading = _ref._uploading,
              rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
            return rest;
          })
        });
        console.log('[drinkCard save] payload:', JSON.stringify({
          id: payload.id,
          showInCart: payload.showInCart,
          showInPayment: payload.showInPayment
        }));
        (0, _drinkCard.saveDrinkCard)(payload).then(function (res) {
          console.log('[drinkCard save] res:', JSON.stringify(res));
          if (res && res.code && res.code !== 200) {
            _this0.$message.error(res.message || '保存失败');
          } else {
            _this0.$message.success('保存成功');
            _this0.editVisible = false;
            _this0.fetchList();
          }
        }).catch(function (err) {
          console.error('[drinkCard save] error:', err);
        }).finally(function () {
          _this0.saving = false;
        });
      });
    },
    resetForm: function resetForm() {
      var _this1 = this;
      this.editForm = defaultForm();
      this.$nextTick(function () {
        if (_this1.$refs.editFormRef) _this1.$refs.editFormRef.clearValidate();
      });
    },
    triggerUpload: function triggerUpload(field) {
      var refName = 'upload_' + field;
      var input = this.$refs[refName];
      var el = Array.isArray(input) ? input[0] : input;
      if (el) el.click();
    },
    handleUpload: function handleUpload(e, field) {
      var _this10 = this;
      var file = e.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', '/drinkCard/');
      this.$set(this.uploadingMap, field, true);
      (0, _drinkCard.uploadImage)(formData).then(function (res) {
        _this10.editForm[field] = res.data;
        _this10.$message.success('上传成功');
      }).catch(function () {
        _this10.$message.error('上传失败');
      }).finally(function () {
        e.target.value = '';
        _this10.$set(_this10.uploadingMap, field, false);
      });
    },
    triggerItemUpload: function triggerItemUpload(idx) {
      var input = this.$refs['upload_item_' + idx];
      var el = Array.isArray(input) ? input[0] : input;
      if (el) el.click();
    },
    // 券明细：保存券别名（即时更新全局券项 xy_coupon_package_item）
    saveCouponAlias: function saveCouponAlias(row) {
      var _this11 = this;
      if (!row.id) return;
      (0, _couponPackage.updateCouponAlias)({
        id: row.id,
        couponAlias: row.couponAlias || ''
      }).then(function () {
        _this11.$message.success('券别名已保存');
      }).catch(function () {
        _this11.$message.error('保存失败');
      });
    },
    triggerCouponUpload: function triggerCouponUpload(row) {
      var input = this.$refs['upload_coupon_' + row.id];
      var el = Array.isArray(input) ? input[0] : input;
      if (el) el.click();
    },
    handleCouponUpload: function handleCouponUpload(e, row) {
      var _this12 = this;
      var file = e.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', '/couponPackage/');
      this.$set(row, '_uploading', true);
      (0, _drinkCard.uploadImage)(formData).then(function (res) {
        return (0, _couponPackage.updateCouponImg)({
          id: row.id,
          couponImgUrl: res.data
        }).then(function () {
          _this12.$set(row, 'couponImgUrl', res.data);
          _this12.$message.success('券封面已保存');
        });
      }).catch(function () {
        _this12.$message.error('上传失败');
      }).finally(function () {
        e.target.value = '';
        _this12.$set(row, '_uploading', false);
      });
    },
    clearCouponImg: function clearCouponImg(row) {
      var _this13 = this;
      (0, _couponPackage.updateCouponImg)({
        id: row.id,
        couponImgUrl: ''
      }).then(function () {
        _this13.$set(row, 'couponImgUrl', '');
        _this13.$message.success('已清除');
      }).catch(function () {
        _this13.$message.error('操作失败');
      });
    },
    handleItemUpload: function handleItemUpload(e, item) {
      var _this14 = this;
      var file = e.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('path', '/drinkCard/');
      this.$set(item, '_uploading', true);
      (0, _drinkCard.uploadImage)(formData).then(function (res) {
        _this14.$set(item, 'iconUrl', res.data);
        _this14.$message.success('上传成功');
      }).catch(function () {
        _this14.$message.error('上传失败');
      }).finally(function () {
        e.target.value = '';
        _this14.$set(item, '_uploading', false);
      });
    }
  }
};